import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const dt = (v) => (v ? new Date(v).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : '—');

export const ReportOrdersPanel = ({ token }) => {
  const [ordini, setOrdini] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const fetchOrdini = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/admin/report-orders`, { headers: { Authorization: `Bearer ${token}` } });
      setOrdini(res.data.ordini || []);
    } catch (e) {
      toast.error('Errore caricamento ordini report');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOrdini(); }, []);

  const inviaProve = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/admin/report-preview`, {}, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Email di prova inviate ad assistenza@casalisilvia.com');
    } catch (e) {
      toast.error('Invio email di prova fallito');
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="report-orders-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h2 className="font-heading text-xl text-white">REPORT DI RISPARMIO FISCALE · 97 €</h2>
        <div className="flex gap-2">
          <button onClick={fetchOrdini} data-testid="report-refresh-btn"
            className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 text-white/70 px-4 py-2 rounded text-sm">
            <RefreshCw size={14} /> Aggiorna
          </button>
          <button onClick={inviaProve} disabled={sending} data-testid="report-preview-btn"
            className="flex items-center gap-2 bg-gold/15 hover:bg-gold/25 border border-gold/40 text-gold px-4 py-2 rounded text-sm disabled:opacity-50">
            <Mail size={14} /> {sending ? 'Invio...' : 'Invia email di prova'}
          </button>
        </div>
      </div>

      {loading && <p className="text-white/50 text-sm">Caricamento...</p>}
      {!loading && ordini.length === 0 && (
        <p className="text-white/50 text-sm" data-testid="report-orders-empty">Nessun ordine del report, per ora.</p>
      )}

      {ordini.length > 0 && (
        <div className="overflow-x-auto border border-white/10 rounded-lg">
          <table className="w-full text-sm">
            <thead className="bg-white/5 text-white/50 text-xs uppercase">
              <tr>
                <th className="p-3 text-left">Pagamento</th>
                <th className="p-3 text-left">Cliente</th>
                <th className="p-3 text-left">Documenti</th>
                <th className="p-3 text-left">Scadenza consegna</th>
                <th className="p-3 text-left">Origine</th>
                <th className="p-3 text-left">Check-up</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {ordini.map((o) => (
                <tr key={o.id} data-testid={`report-order-${o.id}`}>
                  <td className="p-3 text-white/80">
                    {dt(o.paid_at || o.created_at)}
                    <div className="text-white/40 text-xs">{o.status === 'paid' ? `${o.amount} €` : o.status}</div>
                  </td>
                  <td className="p-3 text-white/80">{o.email}</td>
                  <td className="p-3">
                    {o.documenti > 0
                      ? <span className="text-emerald-400">{o.documenti} file · {dt(o.documenti_ricevuti_il)}</span>
                      : <span className="text-amber-400">in attesa</span>}
                  </td>
                  <td className="p-3 text-gold">{o.scadenza_consegna || '—'}</td>
                  <td className="p-3 text-white/60">{o.origine}</td>
                  <td className="p-3 text-white/60 text-xs">
                    {o.cid ? (o.checkup ? 'risposte collegate' : `cid ${o.cid.slice(0, 10)}`) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p className="text-white/40 text-xs mt-4">
        La scadenza è calcolata in 5 giorni lavorativi dal ricevimento dei documenti, esclusi sabato, domenica e festivi.
      </p>
    </div>
  );
};
